import { Mapper } from "../../../../base/utils/mapper";
import { ValidateFollowupModel } from "../../../../domain/models/comercial/validate-followup.model";
import { ValidateFollowupEntity } from "../entities/validate-followup.entity";


export class ValidateFollowupImplementationRepositoryMapper extends Mapper<ValidateFollowupEntity, ValidateFollowupModel> {
    mapFrom(param: ValidateFollowupEntity): ValidateFollowupModel {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        };
    }
    mapTo(param: ValidateFollowupModel): ValidateFollowupEntity {
        return {
            data:param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors:param.errors
        }
    }
}